module.exports = __webpack_public_path__ + "img/LATIN10_02.92ea809f.jpg";